/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      fname
      Position
      location
      mname
      lname
      role
      division
      status
      username
      signatureLoc
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      fname
      Position
      location
      mname
      lname
      role
      division
      status
      username
      signatureLoc
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      fname
      Position
      location
      mname
      lname
      role
      division
      status
      username
      signatureLoc
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createLOI = /* GraphQL */ `
  mutation CreateLOI(
    $input: CreateLOIInput!
    $condition: ModelLOIConditionInput
  ) {
    createLOI(input: $input, condition: $condition) {
      id
      instruction_title
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateLOI = /* GraphQL */ `
  mutation UpdateLOI(
    $input: UpdateLOIInput!
    $condition: ModelLOIConditionInput
  ) {
    updateLOI(input: $input, condition: $condition) {
      id
      instruction_title
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteLOI = /* GraphQL */ `
  mutation DeleteLOI(
    $input: DeleteLOIInput!
    $condition: ModelLOIConditionInput
  ) {
    deleteLOI(input: $input, condition: $condition) {
      id
      instruction_title
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createCOI = /* GraphQL */ `
  mutation CreateCOI(
    $input: CreateCOIInput!
    $condition: ModelCOIConditionInput
  ) {
    createCOI(input: $input, condition: $condition) {
      id
      application
      applicant_email
      application_name
      application_status
      building_professional
      building_professionals_email
      instruction_title
      instruction_list
      instructionlist1
      loi_category
      ownedBy
      division
      oic_city_building_official
      site_inspector_technical_evaluator
      section_chief
      chief_final_permits
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateCOI = /* GraphQL */ `
  mutation UpdateCOI(
    $input: UpdateCOIInput!
    $condition: ModelCOIConditionInput
  ) {
    updateCOI(input: $input, condition: $condition) {
      id
      application
      applicant_email
      application_name
      application_status
      building_professional
      building_professionals_email
      instruction_title
      instruction_list
      instructionlist1
      loi_category
      ownedBy
      division
      oic_city_building_official
      site_inspector_technical_evaluator
      section_chief
      chief_final_permits
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteCOI = /* GraphQL */ `
  mutation DeleteCOI(
    $input: DeleteCOIInput!
    $condition: ModelCOIConditionInput
  ) {
    deleteCOI(input: $input, condition: $condition) {
      id
      application
      applicant_email
      application_name
      application_status
      building_professional
      building_professionals_email
      instruction_title
      instruction_list
      instructionlist1
      loi_category
      ownedBy
      division
      oic_city_building_official
      site_inspector_technical_evaluator
      section_chief
      chief_final_permits
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createActionTaken = /* GraphQL */ `
  mutation CreateActionTaken(
    $input: CreateActionTakenInput!
    $condition: ModelActionTakenConditionInput
  ) {
    createActionTaken(input: $input, condition: $condition) {
      id
      action_taken
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateActionTaken = /* GraphQL */ `
  mutation UpdateActionTaken(
    $input: UpdateActionTakenInput!
    $condition: ModelActionTakenConditionInput
  ) {
    updateActionTaken(input: $input, condition: $condition) {
      id
      action_taken
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteActionTaken = /* GraphQL */ `
  mutation DeleteActionTaken(
    $input: DeleteActionTakenInput!
    $condition: ModelActionTakenConditionInput
  ) {
    deleteActionTaken(input: $input, condition: $condition) {
      id
      action_taken
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createBasic = /* GraphQL */ `
  mutation CreateBasic(
    $input: CreateBasicInput!
    $condition: ModelBasicConditionInput
  ) {
    createBasic(input: $input, condition: $condition) {
      id
      basic
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateBasic = /* GraphQL */ `
  mutation UpdateBasic(
    $input: UpdateBasicInput!
    $condition: ModelBasicConditionInput
  ) {
    updateBasic(input: $input, condition: $condition) {
      id
      basic
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteBasic = /* GraphQL */ `
  mutation DeleteBasic(
    $input: DeleteBasicInput!
    $condition: ModelBasicConditionInput
  ) {
    deleteBasic(input: $input, condition: $condition) {
      id
      basic
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createPayitem = /* GraphQL */ `
  mutation CreatePayitem(
    $input: CreatePayitemInput!
    $condition: ModelPayitemConditionInput
  ) {
    createPayitem(input: $input, condition: $condition) {
      id
      payitem_details
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updatePayitem = /* GraphQL */ `
  mutation UpdatePayitem(
    $input: UpdatePayitemInput!
    $condition: ModelPayitemConditionInput
  ) {
    updatePayitem(input: $input, condition: $condition) {
      id
      payitem_details
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deletePayitem = /* GraphQL */ `
  mutation DeletePayitem(
    $input: DeletePayitemInput!
    $condition: ModelPayitemConditionInput
  ) {
    deletePayitem(input: $input, condition: $condition) {
      id
      payitem_details
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createCreateOrderOfPayment = /* GraphQL */ `
  mutation CreateCreateOrderOfPayment(
    $input: CreateCreateOrderOfPaymentInput!
    $condition: ModelCreateOrderOfPaymentConditionInput
  ) {
    createCreateOrderOfPayment(input: $input, condition: $condition) {
      id
      order_payment_no
      name_of_applicant
      project_location
      project_name
      control_no
      notice_of_payment_no
      application_no
      order_of_payment_details
      listOfInspector
      attachementFile
      grand_total_payment_no
      signature1
      floorArea
      signature2
      nameofsignature1
      nameofsignature2
      opStatus
      applicant_email
      billing_officer
      billing_officer_signature
      inspection_report
      ORNumber
      disapproved
      forwardDate
      approved1Date
      approved2Date
      PostFlag
      remarks
      OrDate
      isDeleted
      ownedBy
      createdAt
      division
      updatedAt
      owner
    }
  }
`;
export const updateCreateOrderOfPayment = /* GraphQL */ `
  mutation UpdateCreateOrderOfPayment(
    $input: UpdateCreateOrderOfPaymentInput!
    $condition: ModelCreateOrderOfPaymentConditionInput
  ) {
    updateCreateOrderOfPayment(input: $input, condition: $condition) {
      id
      order_payment_no
      name_of_applicant
      project_location
      project_name
      control_no
      notice_of_payment_no
      application_no
      order_of_payment_details
      listOfInspector
      attachementFile
      grand_total_payment_no
      signature1
      floorArea
      signature2
      nameofsignature1
      nameofsignature2
      opStatus
      applicant_email
      billing_officer
      billing_officer_signature
      inspection_report
      ORNumber
      disapproved
      forwardDate
      approved1Date
      approved2Date
      PostFlag
      remarks
      OrDate
      isDeleted
      ownedBy
      createdAt
      division
      updatedAt
      owner
    }
  }
`;
export const deleteCreateOrderOfPayment = /* GraphQL */ `
  mutation DeleteCreateOrderOfPayment(
    $input: DeleteCreateOrderOfPaymentInput!
    $condition: ModelCreateOrderOfPaymentConditionInput
  ) {
    deleteCreateOrderOfPayment(input: $input, condition: $condition) {
      id
      order_payment_no
      name_of_applicant
      project_location
      project_name
      control_no
      notice_of_payment_no
      application_no
      order_of_payment_details
      listOfInspector
      attachementFile
      grand_total_payment_no
      signature1
      floorArea
      signature2
      nameofsignature1
      nameofsignature2
      opStatus
      applicant_email
      billing_officer
      billing_officer_signature
      inspection_report
      ORNumber
      disapproved
      forwardDate
      approved1Date
      approved2Date
      PostFlag
      remarks
      OrDate
      isDeleted
      ownedBy
      createdAt
      division
      updatedAt
      owner
    }
  }
`;
export const createCreateOrderOfBilling = /* GraphQL */ `
  mutation CreateCreateOrderOfBilling(
    $input: CreateCreateOrderOfBillingInput!
    $condition: ModelCreateOrderOfBillingConditionInput
  ) {
    createCreateOrderOfBilling(input: $input, condition: $condition) {
      id
      typeofapplication
      application_no
      owner
      occupancy
      project_activity
      Payitem
      locations
      Signature1
      Signature2
      opStatus
      status
      signatureDate1
      signatureDate2
      opStatusDate1
      order_payment_no
      billing_officer
      nameofapprover4
      nameofapprover5
      adminUserName
      dateAdminUpdate
      oic_zoning_administrator
      application_type
      OrNumber
      OrDate
      grandTotal
      lot_no
      blk_no
      location_street
      location_barangay
      location_district
      zone_classification
      lot_area
      floor_area
      no_of_units
      tct_no
      evaluation_facts
      evaluation_facts_extended
      lcNo
      ceNo
      isGovementInstitution
      isCleared
      doesHaveOldOP
      isNoPaymenItem
      isClearedDate
      postalAddress
      counselResolutionNo
      counselResolutionDate
      deniedRemarks
      deniedDate
      isDeny
      isDeleted
      address
      isDeletedDate
      whyDeletedRemarks
      ownedBy
      division
      createdAt
      updatedAt
    }
  }
`;
export const updateCreateOrderOfBilling = /* GraphQL */ `
  mutation UpdateCreateOrderOfBilling(
    $input: UpdateCreateOrderOfBillingInput!
    $condition: ModelCreateOrderOfBillingConditionInput
  ) {
    updateCreateOrderOfBilling(input: $input, condition: $condition) {
      id
      typeofapplication
      application_no
      owner
      occupancy
      project_activity
      Payitem
      locations
      Signature1
      Signature2
      opStatus
      status
      signatureDate1
      signatureDate2
      opStatusDate1
      order_payment_no
      billing_officer
      nameofapprover4
      nameofapprover5
      adminUserName
      dateAdminUpdate
      oic_zoning_administrator
      application_type
      OrNumber
      OrDate
      grandTotal
      lot_no
      blk_no
      location_street
      location_barangay
      location_district
      zone_classification
      lot_area
      floor_area
      no_of_units
      tct_no
      evaluation_facts
      evaluation_facts_extended
      lcNo
      ceNo
      isGovementInstitution
      isCleared
      doesHaveOldOP
      isNoPaymenItem
      isClearedDate
      postalAddress
      counselResolutionNo
      counselResolutionDate
      deniedRemarks
      deniedDate
      isDeny
      isDeleted
      address
      isDeletedDate
      whyDeletedRemarks
      ownedBy
      division
      createdAt
      updatedAt
    }
  }
`;
export const deleteCreateOrderOfBilling = /* GraphQL */ `
  mutation DeleteCreateOrderOfBilling(
    $input: DeleteCreateOrderOfBillingInput!
    $condition: ModelCreateOrderOfBillingConditionInput
  ) {
    deleteCreateOrderOfBilling(input: $input, condition: $condition) {
      id
      typeofapplication
      application_no
      owner
      occupancy
      project_activity
      Payitem
      locations
      Signature1
      Signature2
      opStatus
      status
      signatureDate1
      signatureDate2
      opStatusDate1
      order_payment_no
      billing_officer
      nameofapprover4
      nameofapprover5
      adminUserName
      dateAdminUpdate
      oic_zoning_administrator
      application_type
      OrNumber
      OrDate
      grandTotal
      lot_no
      blk_no
      location_street
      location_barangay
      location_district
      zone_classification
      lot_area
      floor_area
      no_of_units
      tct_no
      evaluation_facts
      evaluation_facts_extended
      lcNo
      ceNo
      isGovementInstitution
      isCleared
      doesHaveOldOP
      isNoPaymenItem
      isClearedDate
      postalAddress
      counselResolutionNo
      counselResolutionDate
      deniedRemarks
      deniedDate
      isDeny
      isDeleted
      address
      isDeletedDate
      whyDeletedRemarks
      ownedBy
      division
      createdAt
      updatedAt
    }
  }
`;
export const createBackupcreateorderofpayment = /* GraphQL */ `
  mutation CreateBackupcreateorderofpayment(
    $input: CreateBackupcreateorderofpaymentInput!
    $condition: ModelbackupcreateorderofpaymentConditionInput
  ) {
    createBackupcreateorderofpayment(input: $input, condition: $condition) {
      id
      order_payment_no
      name_of_applicant
      project_location
      project_name
      control_no
      notice_of_payment_no
      application_no
      order_of_payment_details
      listOfInspector
      grand_total_payment_no
      signature1
      signature2
      nameofsignature1
      nameofsignature2
      opStatus
      applicant_email
      billing_officer
      billing_officer_signature
      PostFlag
      ORNumber
      OrDate
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateBackupcreateorderofpayment = /* GraphQL */ `
  mutation UpdateBackupcreateorderofpayment(
    $input: UpdateBackupcreateorderofpaymentInput!
    $condition: ModelbackupcreateorderofpaymentConditionInput
  ) {
    updateBackupcreateorderofpayment(input: $input, condition: $condition) {
      id
      order_payment_no
      name_of_applicant
      project_location
      project_name
      control_no
      notice_of_payment_no
      application_no
      order_of_payment_details
      listOfInspector
      grand_total_payment_no
      signature1
      signature2
      nameofsignature1
      nameofsignature2
      opStatus
      applicant_email
      billing_officer
      billing_officer_signature
      PostFlag
      ORNumber
      OrDate
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteBackupcreateorderofpayment = /* GraphQL */ `
  mutation DeleteBackupcreateorderofpayment(
    $input: DeleteBackupcreateorderofpaymentInput!
    $condition: ModelbackupcreateorderofpaymentConditionInput
  ) {
    deleteBackupcreateorderofpayment(input: $input, condition: $condition) {
      id
      order_payment_no
      name_of_applicant
      project_location
      project_name
      control_no
      notice_of_payment_no
      application_no
      order_of_payment_details
      listOfInspector
      grand_total_payment_no
      signature1
      signature2
      nameofsignature1
      nameofsignature2
      opStatus
      applicant_email
      billing_officer
      billing_officer_signature
      PostFlag
      ORNumber
      OrDate
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createBuildingandlocationalDB = /* GraphQL */ `
  mutation CreateBuildingandlocationalDB(
    $input: CreateBuildingandlocationalDBInput!
    $condition: ModelbuildingandlocationalDBConditionInput
  ) {
    createBuildingandlocationalDB(input: $input, condition: $condition) {
      id
      order_payment_no
      name_of_applicant
      project_location
      project_name
      control_no
      notice_of_payment_no
      application_no
      order_of_payment_details
      listOfInspector
      grand_total_payment_no
      signature1
      signature2
      nameofsignature1
      nameofsignature2
      opStatus
      applicant_email
      billing_officer
      billing_officer_signature
      inspection_report
      ORNumber
      OrDate
      ownedBy
      permit_application_type
      permit_type
      processing_for_divsion
      recommendingapproval
      endorseApproval
      recommendingapprovalPosition
      locational_clearance_no
      disapproved
      floorArea
      billofmaterials
      total_zoning
      total_dbo
      total_quality_zoning
      total_quality_dbo
      in_charge_of_construction
      profession
      prc_no_validity
      ptr_no_validity
      remarks
      locations
      genderType
      createdAt
      division
      updatedAt
      owner
    }
  }
`;
export const updateBuildingandlocationalDB = /* GraphQL */ `
  mutation UpdateBuildingandlocationalDB(
    $input: UpdateBuildingandlocationalDBInput!
    $condition: ModelbuildingandlocationalDBConditionInput
  ) {
    updateBuildingandlocationalDB(input: $input, condition: $condition) {
      id
      order_payment_no
      name_of_applicant
      project_location
      project_name
      control_no
      notice_of_payment_no
      application_no
      order_of_payment_details
      listOfInspector
      grand_total_payment_no
      signature1
      signature2
      nameofsignature1
      nameofsignature2
      opStatus
      applicant_email
      billing_officer
      billing_officer_signature
      inspection_report
      ORNumber
      OrDate
      ownedBy
      permit_application_type
      permit_type
      processing_for_divsion
      recommendingapproval
      endorseApproval
      recommendingapprovalPosition
      locational_clearance_no
      disapproved
      floorArea
      billofmaterials
      total_zoning
      total_dbo
      total_quality_zoning
      total_quality_dbo
      in_charge_of_construction
      profession
      prc_no_validity
      ptr_no_validity
      remarks
      locations
      genderType
      createdAt
      division
      updatedAt
      owner
    }
  }
`;
export const deleteBuildingandlocationalDB = /* GraphQL */ `
  mutation DeleteBuildingandlocationalDB(
    $input: DeleteBuildingandlocationalDBInput!
    $condition: ModelbuildingandlocationalDBConditionInput
  ) {
    deleteBuildingandlocationalDB(input: $input, condition: $condition) {
      id
      order_payment_no
      name_of_applicant
      project_location
      project_name
      control_no
      notice_of_payment_no
      application_no
      order_of_payment_details
      listOfInspector
      grand_total_payment_no
      signature1
      signature2
      nameofsignature1
      nameofsignature2
      opStatus
      applicant_email
      billing_officer
      billing_officer_signature
      inspection_report
      ORNumber
      OrDate
      ownedBy
      permit_application_type
      permit_type
      processing_for_divsion
      recommendingapproval
      endorseApproval
      recommendingapprovalPosition
      locational_clearance_no
      disapproved
      floorArea
      billofmaterials
      total_zoning
      total_dbo
      total_quality_zoning
      total_quality_dbo
      in_charge_of_construction
      profession
      prc_no_validity
      ptr_no_validity
      remarks
      locations
      genderType
      createdAt
      division
      updatedAt
      owner
    }
  }
`;
export const createLogs = /* GraphQL */ `
  mutation CreateLogs(
    $input: CreateLogsInput!
    $condition: ModellogsConditionInput
  ) {
    createLogs(input: $input, condition: $condition) {
      id
      transactionId
      ownedBy
      details
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateLogs = /* GraphQL */ `
  mutation UpdateLogs(
    $input: UpdateLogsInput!
    $condition: ModellogsConditionInput
  ) {
    updateLogs(input: $input, condition: $condition) {
      id
      transactionId
      ownedBy
      details
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteLogs = /* GraphQL */ `
  mutation DeleteLogs(
    $input: DeleteLogsInput!
    $condition: ModellogsConditionInput
  ) {
    deleteLogs(input: $input, condition: $condition) {
      id
      transactionId
      ownedBy
      details
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createRecommendingapproval = /* GraphQL */ `
  mutation CreateRecommendingapproval(
    $input: CreateRecommendingapprovalInput!
    $condition: ModelrecommendingapprovalConditionInput
  ) {
    createRecommendingapproval(input: $input, condition: $condition) {
      id
      recommendingApprovalSignature
      nameofrecommendingApproval
      position
      ownedBy
      details
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateRecommendingapproval = /* GraphQL */ `
  mutation UpdateRecommendingapproval(
    $input: UpdateRecommendingapprovalInput!
    $condition: ModelrecommendingapprovalConditionInput
  ) {
    updateRecommendingapproval(input: $input, condition: $condition) {
      id
      recommendingApprovalSignature
      nameofrecommendingApproval
      position
      ownedBy
      details
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteRecommendingapproval = /* GraphQL */ `
  mutation DeleteRecommendingapproval(
    $input: DeleteRecommendingapprovalInput!
    $condition: ModelrecommendingapprovalConditionInput
  ) {
    deleteRecommendingapproval(input: $input, condition: $condition) {
      id
      recommendingApprovalSignature
      nameofrecommendingApproval
      position
      ownedBy
      details
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createTblLoiGenerator = /* GraphQL */ `
  mutation CreateTblLoiGenerator(
    $input: CreateTblLoiGeneratorInput!
    $condition: ModeltblLoiGeneratorConditionInput
  ) {
    createTblLoiGenerator(input: $input, condition: $condition) {
      id
      reference_no
      loiFor
      section_chief
      chief_division
      recommendingApproval
      loi
      loi_instructions
      evaluator
      referencesDetails
      recommendation
      evaluator_status
      section_chief_status
      chief_division_status
      evaluationResult
      EvaluatorStatus
      createdAt
      ownedBy
      division
      updatedAt
      owner
    }
  }
`;
export const updateTblLoiGenerator = /* GraphQL */ `
  mutation UpdateTblLoiGenerator(
    $input: UpdateTblLoiGeneratorInput!
    $condition: ModeltblLoiGeneratorConditionInput
  ) {
    updateTblLoiGenerator(input: $input, condition: $condition) {
      id
      reference_no
      loiFor
      section_chief
      chief_division
      recommendingApproval
      loi
      loi_instructions
      evaluator
      referencesDetails
      recommendation
      evaluator_status
      section_chief_status
      chief_division_status
      evaluationResult
      EvaluatorStatus
      createdAt
      ownedBy
      division
      updatedAt
      owner
    }
  }
`;
export const deleteTblLoiGenerator = /* GraphQL */ `
  mutation DeleteTblLoiGenerator(
    $input: DeleteTblLoiGeneratorInput!
    $condition: ModeltblLoiGeneratorConditionInput
  ) {
    deleteTblLoiGenerator(input: $input, condition: $condition) {
      id
      reference_no
      loiFor
      section_chief
      chief_division
      recommendingApproval
      loi
      loi_instructions
      evaluator
      referencesDetails
      recommendation
      evaluator_status
      section_chief_status
      chief_division_status
      evaluationResult
      EvaluatorStatus
      createdAt
      ownedBy
      division
      updatedAt
      owner
    }
  }
`;
